import {ApiNoticePermissions} from "../constants/ApiPermissions";
import RulesetBase from "./rulesetBase";

/**
 * Ruleset for notice
 *
 * @class
 * @extends {RulesetBase}
 */
class NoticeRuleset extends RulesetBase {
  defineRules = (userPermissions: string[]): void => {
    const {can} = this.abilityBuilder;
    let onlyRead = false;

    for (let permission of userPermissions) {
      if (
        permission.toUpperCase() ===
        ApiNoticePermissions.readWrite.toUpperCase()
      ) {
        can("Create", "Notice");
        can("Delete", "Notice");
        can("Update", "Notice");
        can("Read", "Notice");
        onlyRead = false;
        break;
      } else if (
        permission.toUpperCase() === ApiNoticePermissions.read.toUpperCase()
      ) {
        onlyRead = true;
      }
    }
    if (onlyRead) {
      can("Read", "Notice");
    }
  };
}

export default NoticeRuleset;
